<template>
	<el-dialog title="Add/Remove Family Member"
						 :visible.sync="$parent.dialog.family"
						 :width="modalWidth"
						 :before-close="clearForm"
						 :close-on-click-modal="false"
						 :append-to-body="false">

		<div v-if="view === 'list'" v-loading="loading.family">
			<div class="table-responsive" v-if="familyMembers.length">

				<table class="table table-striped">
					<thead>
						<tr>
							<th>Name</th>
							<th class="d-none d-xl-table-cell">Email</th>
							<th></th>
						</tr>
					</thead>
					<tbody>
						<tr v-for="f in familyMembers" :key="f.userId">
							<td>{{f.firstname}} {{f.lastname}}<div class="d-none d-xs-block">{{f.email}}</div></td>
							<td class="d-none d-xl-table-cell">{{f.email}}</td>
							<td><a class="text-primary" style="cursor: pointer" @click="remove(f)"><i class="el-icon-remove"></i></a></td>
						</tr>
					</tbody>

				</table>

			</div>
			<div v-else>
				<el-alert type="info" :closable="false" class="mb-2">
					You don't have any family members added to your pass.
				</el-alert>

			</div>
			<el-button type="link" @click.stop="view = 'add'">Add Family Member</el-button>
		</div>
		<div v-else>
			<div class="form">

				<el-alert type="info" :closable="false" class="mb-2" v-if="addState === 'lookup'">
					You will need your family member's email address. If they already have an account, please enter that email address below. Otherwise we will create a new account for them.
				</el-alert>
				<el-alert type="info" :closable="false" class="mb-2" v-if="addState === 'new'">
					We'll need to create a new account for your family member. They will receive an email notification with instructions on how to manage their new account.
				</el-alert>
				<el-alert type="success" show-icon effect="dark" :closable="false" class="mb-2" v-if="addState === 'exists'">
					Looks like we found that account! Submit the form and we'll add {{data.firstname}} to your pass!
				</el-alert>


				<div class="row">
					<div class="form-group col-lg-4 d-block" :class="[{'has-error': errors.has('email')}]">

						<label>Email</label>
						<el-input v-model="data.email" :disabled="addState === 'new' || addState === 'exists'" name="email" data-vv-as="email" class="w-100" v-validate="'required|email'" />
						<span v-if="errors.has('email')">{{errors.first('email')}}</span>
					</div>
				</div>
				<div class="row" v-if="addState === 'new'">
					<div class="form-group col-lg-4 d-block" :class="[{'has-error': errors.has('first name')}]">
						<label>First Name*</label>
						<el-input v-model="data.firstname" name="first name" data-vv-as="first name" class="w-100" v-validate="'required'" />
						<span v-if="errors.has('first name')">{{errors.first('first name')}}</span>
					</div>

					<div class="form-group col-lg-4 d-block" :class="[{'has-error': errors.has('last name')}]">
						<label>Last Name*</label>
						<el-input v-model="data.lastname" name="last name" class="w-100" v-validate="'required'" />
						<span v-if="errors.has('last name')">{{errors.first('last name')}}</span>
					</div>

					<div class="form-group col-lg-4 d-block" :class="[{'has-error': errors.has('phone')}]">
						<label>Phone*</label>
						<el-input v-model="data.phone" name="phone" class="w-100" v-validate="'required'" />
						<span v-if="errors.has('phone')">{{errors.first('phone')}}</span>
					</div>

				</div>

			</div>
		</div>

		<el-alert type="info" show-icon :title="waiting" class="mt-3" v-if="waiting" :closable="false" effect="dark"></el-alert>
		
		<el-alert :title="serverError" v-if="serverError"
							type="error"
							effect="dark"
							show-icon
							:closable="false" class="mt-4">
		</el-alert>



		<span slot="footer" class="dialog-footer">
			<span v-if="view === 'add'">
				<el-button :disabled="thinking.save" @click="view = 'list'; addState = 'lookup'">Cancel</el-button>&nbsp;
				<el-button v-if="addState === 'lookup'" :loading="thinking.save" type="primary" @click="lookup">Search</el-button>
				<el-button v-if="addState === 'new' || addState === 'exists'" :loading="thinking.save" type="primary" @click="submit">Add {{data.firstname}}</el-button>
			</span>

			<span v-if="view === 'list'">
				<el-button :disabled="thinking.save" @click="clearForm(true)">Cancel</el-button>&nbsp;
			</span>


		</span>
	</el-dialog>
	

</template>

<script>
	import { mapGetters, mapActions } from "vuex";
	import { rest } from "@/utilities/rest.js";
	export default {
		name: "membership-family",
		data() {

			return {
				thinking: {
					save: false
				},
				loading: {
					family: false
				},
				waiting: null,
				waitingInterval: null,
				view: 'list',
				addState: "lookup",

				data: {
					firstname: null,
					lastname: null,
					email: null,
					userId: null,
					profileUserId: null
				},

				serverError: null
			}
		},
		props: ["user", "payment"],
		computed: {
			...mapGetters({
				modalWidth: "modalWidth",
				familyMembers: "familyMembers",
				familyConfig: "familyConfig"
			})
		},
		created() {
			this.data.profileUserId = this.user.userId;
		},
		methods: {

			...mapActions({
				getFamilyMembers: "getFamilyMembers"
			}),

			clearForm(closeDialog) {
				this.data.firstname = null;
				this.data.lastname = null;
				this.data.email = null;
				this.data.userId = null;
				this.addState = "lookup";
				this.view = "list";
				if (closeDialog !== false) {
					this.$parent.dialog.family = false
				}
				
			},

			lookup() {
				this.$validator.validateAll().then(valid => {
					if (valid) {
						this.thinking.save = true;
						rest.get("Account", "/FindUser", "json", { email: this.data.email }).then(response => {
							this.addState = "exists";
							this.data.firstname = response.firstname;
							this.data.lastname = response.lastname;							
						}).fail((xhr) => {
							this.addState = "new";
						}).always(() => {
							this.thinking.save = false;
						});
					}
				});
			},

			submit() {
				this.$validator.validateAll().then(valid => {
					if (valid) {
						this.thinking.save = true;

						let vm = this;
						vm.waiting = vm.familyConfig.waiting.messages[0];
						vm.waitingInterval = setInterval(() => {
								var currIdx =vm.familyConfig.waiting.messages.indexOf(vm.waiting);
								if ((vm.familyConfig.waiting.messages.length - 1) === currIdx) {
									// Do nothing
									
								
								} else {
									vm.waiting = vm.familyConfig.waiting.messages[currIdx + 1];
								}
							
						}, vm.familyConfig.waiting.seconds * 1000);


						
						rest.post("Account", "/AddFamilyMember", "json", JSON.stringify(this.data)).then(response => {
							this.$message.success(this.data.firstname + " was successfully added to your pass.");
							this.loading.family = true;
							this.getFamilyMembers(this.user.userId).then(response => {

							}, error => {
								this.serverError = error;
							}).finally(() => {
								this.loading.family = false;
							});

						}).fail((xhr) => {
							this.serverError = JSON.parse(xhr.responseText).Message;
						}).always(() => {
							this.thinking.save = false;
							clearInterval(vm.waitingInterval);
							vm.waiting = null;
							this.clearForm(false);

						});
					}
				});
			},

			remove(payload) {


				this.$confirm('Are you sure?', 'Warning', {
          confirmButtonText: 'YES',
          cancelButtonText: 'NO',
          type: 'warning'
        }).then(() => {

					this.thinking.save = true;
					this.loading.family = true;
					payload.profileUserId = this.user.userId;
					rest.post("Account", "/RemoveFamilyMember", "json", JSON.stringify(payload)).then(response => {
						this.$message.success(payload.firstname + " was successfully removed from your pass.");
						this.loading.family = true;
						this.getFamilyMembers(this.user.userId).then(response => {

						}, error => {
							this.serverError = error;
						}).finally(() => {
							this.loading.family = false;
						});

					}).fail((xhr) => {
						this.serverError = JSON.parse(xhr.responseText).Message;
					}).always(() => {
						this.thinking.save = false;
						this.loading.family = true;
						this.clearForm(false);

					});

        }).catch(() => {
                
        });

				
			}
		},

		
		watch: {
			'data.email': function (val) {
				let exists = this.familyMembers.filter(m => {
					return m.email.toLowerCase() === val.toLowerCase();
				}).length > 0;
				if (exists) {
					this.data.email = "";
					this.$message.error("This family member already exists on your pass.");
				}
			},
			'data.phone': function (val) {
				if (val && val.length) {
					var x = val.replace(/\D/g, '').match(/(\d{0,3})(\d{0,3})(\d{0,4})/);
					this.data.phone = !x[2] ? x[1] : '(' + x[1] + ') ' + x[2] + (x[3] ? '-' + x[3] : '');
				}				
			}
		}
	}
</script>